import Vue from 'vue'
import Router from 'vue-router'
import HomePage from '@/components/HomePage'
import SearchStore from '@/components/SearchStore'
import SearchCommodity from '@/components/SearchCommodity'
import Login from '@/components/Login'
import GoodsDetail from '@/components/GoodsDetail/GoodsDetail'
import Cart from '@/components/Cart/Cart'
import CreatOrder from '@/components/CreatOrder/CreatOrder'
import SellCenter from '@/components/SellCenter/SellCenter'
import MyCommodity from '@/components/SellCenter/MyCommodity'
import CommodityAdd from '@/components/SellCenter/CommodityAdd'
import Whitebar from '@/components/SellCenter/Whitebar'
import ChoiceWhitebar from '@/components/SellCenter/ChoiceWhitebar'
import AddWhitebar from '@/components/SellCenter/AddWhitebar'
import StaffPage from '@/components/SellCenter/StaffPage'
import OrderManage from '@/components/SellCenter/OrderManage'
import StoreWallateRecharge from '@/components/SellCenter/StoreWallateRecharge'
import StoreWithdrawal from '@/components/SellCenter/StoreWithdrawal'
import PrepayRecharge from '@/components/prepayRecharge/PrepayRecharge'
import MutlOrderSettingPrice from '@/components/SellCenter/MutlOrderSettingPrice'
import CustomeManage from '@/components/SellCenter/CustomeManage'

import PublishMessage from '@/components/SellCenter/PublishMessage'
import StoreBuyOrder from '@/components/SellCenter/StoreBuyOrder'
import StoreSellOrder from '@/components/SellCenter/StoreSellOrder'
import MoneyManage from '@/components/SellCenter/MoneyManage'
import StoreAddWidthDrawalCard from '@/components/SellCenter/StoreAddWidthDrawalCard'
import RoleSetting from '@/components/SellCenter/RoleSetting'
import AddStaff from '@/components/SellCenter/AddStaff'
import ChildStoreWidthDrawalCard from '@/components/SellCenter/ChildStoreWidthDrawalCard'
import MoneyCalculete from '@/components/SellCenter/MoneyCalculete'
import UpLoadThing from '@/components/SellCenter/UpLoadThing'
import CustomeSetting from '@/components/SellCenter/CustomeSetting'
import DiscountManage from '@/components/SellCenter/DiscountManage'
import AddDiscount from '@/components/SellCenter/AddDiscount'
import AddCustome from '@/components/SellCenter/AddCustome'
import AddDiscountCustom from '@/components/SellCenter/AddDiscountCustom'
import AddDiscountGoods from '@/components/SellCenter/AddDiscountGoods'




import MyOrder from '@/components/MyOrder/MyOrder'
import PayPage from '@/components/PayPage'
import IndustryInformation from '@/components/IndustryInformation'
import SettingPage from '@/components/SettingPage/SettingPage'
import AddressSetting from '@/components/SettingPage/components/AddressSetting'
import PersonAuth from '@/components/Authen/PersonAuth'
import StoreAuth from '@/components/Authen/StoreAuth'
import Auth from '@/components/Authen/Auth'
import SupplyPage from '@/components/SupplyPage'
import DemandPage from '@/components/DemandPage'
import StoreHomePage from '@/components/StoreHomePage'
import AddPayCard from '@/components/AddPayCard'
import IssueAgreement from '@/components/agreement/IssueAgreement'
import ServiceAgreement from '@/components/agreement/ServiceAgreement'


import { isBeijing } from '@/api/api'

Vue.use(Router)

let router = new Router({
    routes: [{
        path: '/',
        name: 'homePage',
        component: HomePage,
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
    },
    {
        path: '/searchStore',
        name: 'searchStore',
        component: SearchStore,
    },
    {
        path: '/goodsDetail',
        name: 'goodsDetail',
        component: GoodsDetail,
    },
    {
        path: '/cart',
        name: 'cart',
        component: Cart,
    },
    {
        path: '/creatOrder',
        name: 'creatOrder',
        component: CreatOrder,
    },
    {
        path: '/sellCenter',
        name: 'sellCenter',
        component: SellCenter,
        children: [
            { path: 'whitebar', name: "whitebar", component: Whitebar }, //仓库管理
            { path: 'staffPage', name: "staffPage", component: StaffPage }, //员工管理
            { path: 'myCommodity', name: "myCommodity", component: MyCommodity }, //商品管理
            { path: 'addWhitebar', name: "addWhitebar", component: AddWhitebar }, //商品管理
            { path: 'commodityAdd', name: "commodityAdd", component: CommodityAdd }, //创建商品
            { path: 'storeBuyOrder', name: "storeBuyOrder", component: StoreBuyOrder }, //采购订单
            { path: 'storeSellOrder', name: "storeSellOrder", component: StoreSellOrder }, //销售订单
            { path: 'moneyManage', name: "moneyManage", component: MoneyManage }, //店铺钱包
            { path: 'storeWallateRecharge', name: "storeWallateRecharge", component: StoreWallateRecharge }, //店铺钱包
            { path: 'storeWithdrawal', name: "storeWithdrawal", component: StoreWithdrawal }, //店铺钱包
            // { path: 'prepayRecharge', name: "prepayRecharge", component: PrepayRecharge }, //店铺钱包
            { path: 'storeAddWidthDrawalCard', name: "storeAddWidthDrawalCard", component: StoreAddWidthDrawalCard }, //店铺钱包
            { path: 'roleSetting', name: "roleSetting", component: RoleSetting }, //角色设置
            { path: 'addStaff', name: "addStaff", component: AddStaff }, //添加员工
            { path: 'mutlOrderSettingPrice', name: "mutlOrderSettingPrice", component: MutlOrderSettingPrice }, //多商品改价
            { path: 'childStoreWidthDrawalCard', name: "childStoreWidthDrawalCard", component: ChildStoreWidthDrawalCard },
            { path: 'moneyCalculete', name: "moneyCalculete", component: MoneyCalculete }, //结算中心
            { path: 'upLoadThing', name: "upLoadThing", component: UpLoadThing }, //结算中心
            { path: 'customeManage', name: "customeManage", component: CustomeManage }, //客户管理
            { path: 'customeSetting', name: "customeSetting", component: CustomeSetting }, //客户编辑
            { path: 'discountManage', name: "discountManage", component: DiscountManage }, //优惠管理
            { path: 'addDiscount', name: "addDiscount", component: AddDiscount }, //添加优惠
            { path: 'addCustome', name: "addCustome", component: AddCustome }, //添加客户
            { path: 'addDiscountCustom', name: "addDiscountCustom", component: AddDiscountCustom }, //优惠设置选择目标客户
            { path: 'addDiscountGoods', name: "addDiscountGoods", component: AddDiscountGoods }, //优惠设置选择目标商品
        ]
    },
    {
        path: '/publishMessage',
        name: 'publishMessage',
        component: PublishMessage,
    },

    {
        path: '/prepayRecharge',
        name: 'prepayRecharge',
        component: PrepayRecharge,
    },
    {
        path: '/myCommodity',
        name: 'myCommodity',
        component: MyCommodity,
    },
    {
        path: '/commodityAdd',
        name: 'commodityAdd',
        component: CommodityAdd,
    },
    {
        path: '/myOrder',
        name: 'myOrder',
        component: MyOrder,
    },
    {
        path: '/supplyPage',
        name: 'supplyPage',
        component: SupplyPage,
    },
    {
        path: '/demandPage',
        name: 'demandPage',
        component: DemandPage,
    },
    {
        path: '/payPage',
        name: 'payPage',
        component: PayPage,
    },
    {
        path: '/whitebar',
        name: 'whitebar',
        component: Whitebar,
    },
    {
        path: '/choiceWhitebar',
        name: 'choiceWhitebar',
        component: ChoiceWhitebar,
    },
    {
        path: '/addWhitebar',
        name: 'addWhitebar',
        component: AddWhitebar,
    },
    {
        path: '/searchCommodity',
        name: 'searchCommodity',
        component: SearchCommodity,
    },
    {
        path: '/settingPage',
        name: 'settingPage',
        component: SettingPage,
        children: [
            { path: 'addressSetting', name: "addressSetting", component: AddressSetting }, //收货地址管理
        ]
    },
    {
        path: '/auth',
        name: 'auth',
        component: Auth,
    },
    {
        path: '/auth',
        name: 'auth',
        component: Auth,
        children: [{
            path: 'personAuth',
            name: 'personAuth',
            component: PersonAuth,
        },
        {
            path: 'storeAuth',
            name: 'storeAuth',
            component: StoreAuth,
        },
        ]
    },
    {
        path: '/industryInformation',
        name: 'industryInformation',
        component: IndustryInformation,
    },
    {
        path: '/staffPage',
        name: 'staffPage',
        component: StaffPage,
    },
    {
        path: '/orderManage',
        name: 'orderManage',
        component: OrderManage,
    },
    {
        path: '/storeHomePage',
        name: 'storeHomePage',
        component: StoreHomePage,
    },
    {
        path: '/addPayCard',
        name: 'addPayCard',
        component: AddPayCard,
    },
    {
        path: '/serviceAgreement',
        name: 'serviceAgreement',
        component: ServiceAgreement,
    },
    {
        path: '/issueAgreement',
        name: 'issueAgreement',
        component: IssueAgreement,
    },
    ],
    mode: 'hash',
    base: '/', //打包添加的地方
})

router.beforeEach((to, from, next) => {
    window.scrollTo(0, 0)
    next()
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js